import React, { useState } from 'react';
import { useTimeout } from '../../hooks/useTimeout';
import { LoadingSpinner } from './LoadingSpinner';

export interface CenteredLoadingSpinnerProps {
  colorMode?: 'light' | 'dark';
  height?: string;
  /** Delay to wait until showing the spinner. Will show immediately if 0. */
  delay?: number;
  size?: number;
  style?: React.CSSProperties;
  message?: string;
}

export const CenteredLoadingSpinner: React.FC<CenteredLoadingSpinnerProps> = ({
  height,
  delay,
  size,
  style,
  colorMode,
  message,
}) => {
  const [show, setShow] = useState(delay === undefined);

  useTimeout(() => setShow(true), delay, [delay]);

  if (!show) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: height ?? '100%',
        width: '100%',
        gap: '1em',
        ...style,
      }}
    >
      <LoadingSpinner colorMode={colorMode || 'light'} size={size} />
      {message && <div style={{ fontFamily: 'Roboto, Helvetica, sans-serif' }}>{message}</div>}
    </div>
  );
};
